var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41667 30.5006H2.75V13.1673H9.41667V30.5006ZM21.4167 18.5007C20.7094 18.5007 20.0311 18.7816 19.531 19.2817C19.031 19.7818 18.75 20.4601 18.75 21.1673V30.5006H12.0833V13.1673H18.75V15.1473C20.2384 13.8858 22.1191 13.1812 24.07 13.154C28.0193 13.154 30.75 16.0873 30.75 21.6273V30.5006H24.0833V21.1673C24.0833 20.4601 23.8024 19.7818 23.3023 19.2817C22.8022 18.7816 22.1239 18.5007 21.4167 18.5007V18.5007ZM9.41667 7.16732C9.41667 7.82659 9.22117 8.47105 8.8549 9.01922C8.48863 9.56738 7.96803 9.99462 7.35895 10.2469C6.74986 10.4992 6.07964 10.5652 5.43303 10.4366C4.78643 10.308 4.19249 9.99051 3.72631 9.52434C3.26014 9.05816 2.94267 8.46422 2.81405 7.81762C2.68543 7.17102 2.75144 6.50079 3.00374 5.89171C3.25603 5.28262 3.68327 4.76202 4.23143 4.39575C4.7796 4.02948 5.42406 3.83398 6.08333 3.83398C6.96739 3.83398 7.81524 4.18517 8.44036 4.8103C9.06548 5.43542 9.41667 6.28326 9.41667 7.16732Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.420370e56378439ca88abccc3cfb884f.svg";
export { ForwardRef as ReactComponent };